module.exports = __webpack_public_path__ + "static/img/Send19.8691e78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Send19.png
// module id = m7/G
// module chunks = 0